export type FeatureFlag = 'PUBLIC_ACCOUNT_CREATION';
export type FeatureFlags = { [flag in FeatureFlag]: boolean };

export const activeFeatureFlags: FeatureFlags = {
	PUBLIC_ACCOUNT_CREATION: true,
};
